export const i18n = {
  banks: {
    payment: {
      name: "SINPE",
    },
  },
};
